import { get, set, ref } from "firebase/database";
import { firebase } from "../config/configureFirebase";

export const GenerateInvoiceNo = async () => {
  try {
    const year = new Date().getFullYear();

    // ✅ CORRECT
    const counterRef = ref(firebase.database, `invoiceCounter/${year}`);

    const snapshot = await get(counterRef);

    let lastNumber = snapshot.exists() ? snapshot.val() : 0;

    const newNumber = lastNumber + 1;
    await set(counterRef, newNumber);

    const padded = String(newNumber).padStart(5, "0");

    return `ZR-${year}-${padded}`;

  } catch (err) {
    console.log("INVOICE ERROR:", err);
    return null;
  }
};